/**
 * SKU 级别 AI 配置管理服务
 */

import apiClient from './api';
import { UserPreference } from '../types/ai-analysis-types';

/**
 * 获取指定 SKU 的所有 AI 配置
 */
export async function getSKUAIConfigs(skuId: number): Promise<UserPreference[]> {
  const response = await apiClient.get<UserPreference[]>(`/skus/${skuId}/ai-configs/`);
  return response.data || [];
}

/**
 * 获取指定 SKU 的默认 AI 配置
 */
export async function getSKUDefaultConfig(skuId: number): Promise<UserPreference | null> {
  try {
    const response = await apiClient.get<UserPreference>(`/skus/${skuId}/ai-configs/get_default/`);
    return response.data;
  } catch (error: any) {
    if (error.response?.status === 404) {
      return null;  // 没有默认配置
    }
    throw error;
  }
}

/**
 * 创建新的 SKU AI 配置
 */
export async function createSKUAIConfig(skuId: number, config: Partial<UserPreference>): Promise<UserPreference> {
  const response = await apiClient.post<UserPreference>(`/skus/${skuId}/ai-configs/`, config);
  return response.data;
}

/**
 * 更新 SKU AI 配置
 */
export async function updateSKUAIConfig(skuId: number, configId: number, config: Partial<UserPreference>): Promise<UserPreference> {
  const response = await apiClient.put<UserPreference>(`/skus/${skuId}/ai-configs/${configId}/`, config);
  return response.data;
}

/**
 * 删除 SKU AI 配置
 */
export async function deleteSKUAIConfig(skuId: number, configId: number): Promise<void> {
  await apiClient.delete(`/skus/${skuId}/ai-configs/${configId}/`);
}

/**
 * 将指定配置设为该 SKU 的默认配置
 */
export async function setDefaultConfig(skuId: number, configId: number): Promise<UserPreference> {
  const response = await apiClient.post<UserPreference>(`/skus/${skuId}/ai-configs/${configId}/set_default/`);
  return response.data;
}

/**
 * 克隆配置（创建副本）
 */
export async function cloneConfig(skuId: number, configId: number, newName: string): Promise<UserPreference> {
  const response = await apiClient.post<UserPreference>(
    `/skus/${skuId}/ai-configs/${configId}/clone/`,
    { config_name: newName }
  );
  return response.data;
}

